import { render, staticRenderFns } from "./ShortNotify.vue?vue&type=template&id=dd86642a&scoped=true"
import script from "./ShortNotify.vue?vue&type=script&lang=js"
export * from "./ShortNotify.vue?vue&type=script&lang=js"
import style0 from "./ShortNotify.vue?vue&type=style&index=0&id=dd86642a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd86642a",
  null
  
)

export default component.exports